import {
    ApolloProvider,
    useQuery,
    useLazyQuery,
    useMutation,
    useApolloClient,
} from '@apollo/client';
import { MockedProvider } from '@apollo/client/testing';
import { InMemoryCache } from '@apollo/client/cache';

export default {
    ApolloProvider,
    useQuery,
    useLazyQuery,
    useMutation,
    useApolloClient,
    InMemoryCache,
    MockedProvider,
};
